import { UserInterface } from '../../interfaces/user.interface'
import { LinkedinProfileInterface } from '../../interfaces/profile.interface'

export const getLinkedinProfileHelper = (user?: UserInterface | null): LinkedinProfileInterface | undefined => {
  if (user && user.profiles && user.profiles.length) {
    return user.profiles.find((p) => p.provider === 'linkedin') as LinkedinProfileInterface | undefined
  }
  return undefined
}
